import React, { useEffect, useState } from "react";
import { Row, Col, Form, Container } from "react-bootstrap";
import { connect } from "react-redux";
import { isEmpty, get, find, isUndefined, filter, sumBy } from "lodash";
import { GlobalSpinner, showSuccessAlert, showErrorAlert } from '../../../../../global/globalFunctions'
import { mergeNames } from "../../../../../global/globalFunctions";
import { setHeading } from "../../../accounts/account.actions";
import { GetLevelFourDropDownApi } from "../LevelFour/LevelFourAction";
import { AddVoucherApi, SubmitCashPayment, DeleteCashPayment, ResetCashPayment } from "./VoucherAction";
import Select from "react-select";
import MaterialTable from "material-table";
import moment from 'moment';
import SendIcon from '@mui/icons-material/Send';
import Button from '@mui/material/Button';


const CashPaymentVoucher = (props) => {
    const [accountNo, setaccountNo] = useState(1);
    const [selectedAccount, setSelectedAccount] = useState();
    const [cashAccountTitle, setCashAccountTitle] = useState('');
    const [cashAccountTitleKey, setCashAccountTitleKey] = useState();
    const [voucher, setVoucher] = useState();
    const [cashId, setCashId] = useState("6439abd6b990438a2450690a");
    const [level4Id, setLevel4Id] = useState();
    const [level4Label, setLevel4Lablel] = useState(`3-1-1-1/CASH`);
    const [datestate, setDatestate] = useState(moment(new Date()).format("YYYY-MM-DD"));


    const SaveCashPamentVoucher = () => {
        let dt = cash.map((x) => {
            return x.data;
        })
        let cashData = [{
            voucherDescription: mergeNames(dt, 'voucherDescription'),
            voucherAmount: sumBy(cash, item => Number(item.data.voucherAmount)),
            billNumber: mergeNames(dt, 'billNumber'),
            accountTittle: cashAccountTitle,
            levelFourId: accountNo,
            voucherDate: datestate,
            accountType: "1",
            crossAccount: mergeNames(dt, 'accountTittle'),
            credit: sumBy(cash, item => Number(item.data.voucherAmount)),
            debit: ""
        }]
        props.AddVoucherApi({
            voucherTypeId: "1",
            vocDate: datestate,
            levelFourId: accountNo,
            totalAmount: sumBy(cash, item => Number(item.data.voucherAmount)),
            cashAccTittle: selectedAccount,
            voucher: voucher,
            voucherData: [...dt, ...cashData],
            voucherType: "CPV",
        },
            showSuccessAlert,
            showErrorAlert,
        );
        setaccountNo(1)
        setCashAccountTitle("")
        setCashAccountTitleKey("")
        setSelectedAccount("")
        props.ResetCashPayment();
    };

    const cash = props.cashPayment;
    const [values, setValues] = useState({
        voucherDate: "",
        levelFourId: "",
        accountTittle: "",
        accountType: "2",
        voucherDescription: "",
        voucherAmount: "",
        billNumber: "",
        credit: "",
        debit: "",
        crossAccount: "",
    });
    const inputEvent = (event) => {
        event.target.name == "voucherDate" && setDatestate(event.target.value);
        if (event.target.name == "voucherAmount") {
            setValues({
                ...values,
                [event.target.name]: event.target.value,
                debit: Number(event.target.value)
            })
        } else {
            setValues({
                ...values,
                [event.target.name]: event.target.value,
            })
        }
    };

    const inputEventAccount = (selectedOption, type) => {
        setLevel4Id(selectedOption.value);
        setValues({ levelFourId: selectedOption.value });
    };

    const inputEvent1Account = (selectedOption) => {
        setLevel4Id(selectedOption.value);
        setValues({
            ...values,
            "levelFourId": selectedOption.value,
            "accountTittle":
                get(find(props.levelFourDropDownList, (x) => x._id === selectedOption.value), "allLevelKey", 0) + "(" +
                get(find(props.levelFourDropDownList, (x) => x._id === selectedOption.value), "levelFourName", 0) + ")",
        });
    };
    const cashAccountNoTop = !isEmpty(props.levelFourDropDownList) && props.levelFourDropDownList.filter((x) => x.levelThreeId === cashId).map((y) => {
        let data = {
            value: y._id,
            label: y.allLevelKey + " - " + y.levelFourName,
        };
        return data;
    });


    const handleChangeAccountNo = (selectedOption) => {
        setaccountNo(selectedOption.value);
        setCashAccountTitle(find(props.levelFourDropDownList, (x) => x._id == selectedOption.value).levelFourName);
        setCashAccountTitleKey(find(props.levelFourDropDownList, (x) => x._id == selectedOption.value).allLevelKey);
        setSelectedAccount(selectedOption.label)
    };
    const cashAccountNo = !isEmpty(props.levelFourDropDownList) && props.levelFourDropDownList.map((x) => {
        let data = {
            value: x._id,
            label: x.allLevelKey + " - " + x.levelFourName,
        };
        return data;
    });

    const PostVoucher = () => {
        let newVal = values;
        if (!isEmpty(datestate)) newVal.voucherDate = datestate;
        props.SubmitCashPayment(newVal);
        setValues({
            voucherDescription: "",
            voucherAmount: "",
            billNumber: "",
            accountTittle: "",
            levelFourId: "",
            voucherDate: "",
            accountType: "2",
            credit: "",
            debit: "",
            crossAccount: ""
        });
        setLevel4Lablel("")
    };

    useEffect(() => {
        props.setHeading("Cash Payment Voucher");
        props.GetLevelFourDropDownApi();
    }, []);

    return (
        <>
            {props.isFetchingLevelFourDropDown || props.isAddingVoucher ? (
                <GlobalSpinner />
            ) : (
                <div style={{ marginTop: '-2%' }}>
                    <Container fluid>
                        <Row>
                            <Col lg="4" sm="12">
                                <Form.Group className="mb-3" >
                                    <Form.Label><b>Voucher Date *</b></Form.Label>
                                    <Form.Control
                                        type="date"
                                        name="voucherDate"
                                        value={datestate}
                                        //value={values.voucherDate}
                                        onChange={inputEvent}
                                        max={moment(new Date()).format("YYYY-MM-DD")}
                                        disabled={!isEmpty(props.cashPayment)}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>

                        <Row>
                            <Col>
                                <Form.Group>
                                    <Form.Label><b>Select Account *</b></Form.Label>
                                    <Select
                                        value={{ label: values.accountTittle }}
                                        placeholder="Select Account"
                                        onChange={(inputEventAccount, inputEvent1Account)}
                                        options={filter(cashAccountNo, x => x.value !== accountNo)}
                                    />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group>
                                    <Form.Label><b>Account Type *</b></Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Account Type"
                                        value="Debit"
                                        disabled
                                    />
                                </Form.Group>
                            </Col>
                        </Row>

                        <Row>
                            <Col>
                                <Form.Group>
                                    <Form.Label><b>Select Cash Account *</b></Form.Label>
                                    <Select
                                        value={{ label: cashAccountTitle }}
                                        isDisabled={isUndefined(level4Id) || !isEmpty(accountNo)}
                                        placeholder="Select Cash Account"
                                        onChange={handleChangeAccountNo}
                                        options={filter(cashAccountNoTop, x => x.value !== values.levelFourId)}
                                    />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group>
                                    <Form.Label><b>Account Type *</b></Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Account Type"
                                        value="Credit"
                                        disabled
                                    />
                                </Form.Group>
                            </Col>
                        </Row>

                        <Row>
                            <Col>
                                <Form.Group>
                                    <Form.Label><b>Bill Number</b></Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Bill Number"
                                        name="billNumber"
                                        value={values.billNumber}
                                        onChange={inputEvent}
                                    />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group>
                                    <Form.Label><b>Description</b></Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Description"
                                        // id="descriptionID"
                                        name="voucherDescription"
                                        value={values.voucherDescription}
                                        onChange={inputEvent}
                                    />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group>
                                    <Form.Label><b>Voucher Amount *</b></Form.Label>
                                    <Form.Control
                                        type="number"
                                        placeholder="Voucher Amount"
                                        // id="amountID"
                                        name="voucherAmount"
                                        value={values.voucherAmount}
                                        onChange={inputEvent}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>


                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '80px', marginTop: '15px' }}>
                            <div>
                                <Button
                                    variant="contained"
                                    endIcon={<SendIcon />}
                                    size="large"
                                    disabled={isEmpty(level4Id) || isEmpty(accountNo) || isEmpty(values.voucherAmount)}
                                    onClick={() => { PostVoucher() }}>
                                    POST VOUCHER
                                </Button>
                            </div>
                            <div>
                                <Button
                                    variant="contained"
                                    endIcon={<SendIcon />}
                                    size="large"
                                    onClick={SaveCashPamentVoucher}
                                    disabled={isEmpty(cash)}>
                                    SAVE VOUCHER
                                </Button>
                            </div>
                        </div>


                        <div className="main" style={{ marginTop: '10px' }} >
                            <MaterialTable
                                title={`VOUCHER TOTAL : ${sumBy(cash, item => Number(item.data.voucherAmount))}`}
                                columns={[
                                    { title: "Date", field: "data.voucherDate" },
                                    { title: "Account Name", field: "data.accountTittle" },
                                    { title: "Bill", field: "data.billNumber" },
                                    { title: "Description", field: "data.voucherDescription" },
                                    { title: "Amount", field: "data.voucherAmount", render: rowData => `${rowData.data.voucherAmount}/-` },
                                    { title: "Debit / Credit", field: "data.accountType", render: (rowData) => rowData.data.accountType === "1" ? "Credit" : "Debit" },
                                ]}
                                data={cash}
                                options={{
                                    actionsColumnIndex: -1,
                                    exportButton: false,
                                    exportAllData: false,
                                    paging: false,
                                    pageSize: 50,
                                    emptyRowsWhenPaging: false,
                                    pageSizeOptions: [50, 100, 150, 200],
                                    headerStyle: {
                                        position: "sticky",
                                        top: 0,
                                        color: "#00BBBB",
                                        fontWeight: "550",
                                        onRowAdd: "none",
                                    },
                                }}
                                editable={{
                                    onRowDelete: (oldData) =>
                                        new Promise((resolve) => {
                                            setTimeout(() => {
                                                resolve();
                                                props.DeleteCashPayment(oldData);
                                            }, 600);
                                        }),
                                }}
                            />
                        </div>

                    </Container>
                </div>
            )}
        </>
    );
};
const mapDispatchToProps = (dispatch) => {
    return {
        AddVoucherApi: (data, showSuccessAlert, showErrorAlert) => dispatch(AddVoucherApi(data, showSuccessAlert, showErrorAlert)),
        GetLevelFourDropDownApi: () => dispatch(GetLevelFourDropDownApi()),
        SubmitCashPayment: (data) => dispatch(SubmitCashPayment(data)),
        DeleteCashPayment: (id) => dispatch(DeleteCashPayment(id)),
        ResetCashPayment: () => dispatch(ResetCashPayment()),
        setHeading: (data) => dispatch(setHeading(data)),
    };
};
const mapStateToProps = (state, ownProps) => ({
    isAddingVoucher: state.VouchersReducer.isAddingVoucher,
    cashPayment: state.VouchersReducer.cashPayment,
    levelFourDropDownList: state.LevelFourReducer.levelFourDropDownList,
    isFetchingLevelFourDropDown: state.LevelFourReducer.isFetchingLevelFourDropDown,
});

export default connect(mapStateToProps, mapDispatchToProps)(CashPaymentVoucher);
